import { message } from "ant-design-vue";
const isJsonString = (str) => {
	try {
		if (typeof JSON.parse(decodeURIComponent(str)) == "object") {
			return true
		}
	} catch (e) { }
	return false
}

export const exportFile = (url, qsObj, fileName,platform='seller',method='GET', loadingState = null, showLoading = true) => {
  // console.log(url, qsObj, fileName,platform,method, loadingState, showLoading,'数据')
  const localStoragePrefix = location.hostname;
  const userToken = localStorage.getItem(`${localStoragePrefix}_userToken`);
	let param;
	let xhr = new XMLHttpRequest();
  
  // DOM loading元素引用
  let loadingElement = null;
  
  // 创建页面loading效果
  if (showLoading) {
    loadingElement = createLoadingElement();
    document.body.appendChild(loadingElement);
  }
  
  // 创建loading元素的函数
  function createLoadingElement() {
    const div = document.createElement('div');
    div.id = 'export-loading';
    div.innerHTML = `
      <div class="loading-content">
        <div class="loading-spinner"></div>
        <div class="loading-text">Processing data...This may take 1-2 minutes. </div>
      </div>
    `;
    
    // 设置内联样式
    Object.assign(div.style, {
      position: 'fixed',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: '9999',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    });
    
    const content = div.querySelector('.loading-content');
    Object.assign(content.style, {
      backgroundColor: '',
      borderRadius: '8px',
      padding: '30px 40px',
      textAlign: 'center',
      boxShadow: '0',
      minWidth: '0'
    });
    
    const spinner = div.querySelector('.loading-spinner');
    Object.assign(spinner.style, {
      width: '40px',
      height: '40px',
      border: '4px solid #f3f3f3',
      borderTop: '4px solid #1890ff',
      borderRadius: '50%',
      margin: '0 auto 16px',
      animation: 'spin 1s linear infinite'
    });
    
    const text = div.querySelector('.loading-text');
    Object.assign(text.style, {
      color: '#fff',
      fontSize: '16px',
      fontWeight: '500'
    });
    
    // 添加旋转动画
    const styleSheet = document.createElement('style');
    styleSheet.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(styleSheet);
    
    return div;
  }
    
  // 设置loading状态为true
  if (loadingState && typeof loadingState === 'object' && 'value' in loadingState) {
    loadingState.value = true;
  } else if (typeof loadingState === 'function') {
    loadingState(true);
  }
	let prefix = '';
	if (location.origin.indexOf('admaads') !== -1) {
		prefix = process.env.NODE_ENV === 'production' ? location.origin.replace('admaads', 'apiaads') : ''
	} else if (location.origin.indexOf('aads') !== -1) {
		prefix = process.env.NODE_ENV === 'production' ? location.origin.replace('aads', 'apiaads') : ''
	} else if (location.origin.indexOf('adm') !== -1) {
		prefix = process.env.NODE_ENV === 'production' ? location.origin.replace('adm', 'api') : ''
	} else {
		prefix = process.env.NODE_ENV === 'production' ? location.origin.replace('www', 'api') : ''
	}
	// prefix = process.env.NODE_ENV === 'production' ? location.origin.replace('www', 'api') : '';
	let reqUrl = `${prefix}/api/artemisads/v1/${url}`
  if(platform=='operator'){
    reqUrl=`${prefix}/admin/artemisads/v1/${url}`
  }
  if(platform=='operatorV2'){
    reqUrl=`${prefix}/admin/artemisads/v2/${url}`
  }
	if(method==='POST'){
		xhr.open('POST', `${reqUrl}`, true);
		param=qsObj
		xhr.setRequestHeader('Content-Type', 'application/json');

	}
	else{
		const queryString = Object.keys(qsObj).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(qsObj[key])}`).join('&');
		xhr.open('GET', `${reqUrl}?${queryString}`, true);
		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

	}
  console.log(platform,'platform')
  // xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
  switch(platform){
    case 'seller':
      xhr.setRequestHeader('x-aa-authorization', `Bearer ${userToken}`);
      break;
    case 'operatorV2':
      xhr.setRequestHeader('x-aa-admin-authorization', `Bearer ${userToken}`);
      break;
    case 'operator':
       xhr.setRequestHeader('x-aa-admin-authorization', `Bearer ${userToken}`);
      break;
  }
  

	
	xhr.responseType = 'arraybuffer';
	xhr.onreadystatechange = function() {
		if (this.readyState == this.DONE) {
			if (this.status == 200) {
				let uint8 = new Uint8Array(this.response) // 提取uint8Array
				// 防止数据过大超过调用堆栈大小，进行分片处理
				let uint8String = ''
				const chunk = 8 * 1024
				const groupNum = Math.ceil(
					uint8.length / chunk
				)
				for (let i = 0; i < groupNum; i++) {
					const arr = uint8.subarray(
						i * chunk,
						(i + 1) * chunk
					)
					uint8String += String.fromCharCode(...arr)
				}
				let resToString = decodeURIComponent(
					escape(uint8String).replace(/%/g, '%25')
				)
				let disposition = this.getResponseHeader('Content-Disposition')
				if (!fileName && disposition && /filename="([^"]+)/.test(disposition)) {
					fileName = iconv.decode(RegExp.$1, 'utf-8')
				}
				if (isJsonString(resToString)) {
					let resObj = JSON.parse(decodeURIComponent(resToString))
				} else {
					let type = xhr.getResponseHeader('Content-Type')
					let blob = new Blob([this.response], { type: type })
					if (window.navigator.msSaveOrOpenBlob) {
						navigator.msSaveBlob(blob, fileName)
					} else {
						var link = document.createElement('a')
						link.href = window.URL.createObjectURL(blob)
						if (fileName) {
							link.download = fileName
						}
						link.click()
						window.URL.revokeObjectURL(link.href)
					}
				}

        
				// 设置loading状态为false
        if (loadingState && typeof loadingState === 'object' && 'value' in loadingState) {
          loadingState.value = false;
        } else if (typeof loadingState === 'function') {
          loadingState(false);
        }
        
        // 移除loading元素
        if (loadingElement && document.body.contains(loadingElement)) {
          document.body.removeChild(loadingElement);
        }
          
  				if (typeof callbackFunc === 'function') {
					callbackFunc(true)
				}
				// 暂时先加一个提示，后续再优化
				if(url=='publisher/product/export'){
					message.success('Products Info Exported Successfully!')
				}
			} else {
				if (typeof callbackFunc === 'function') {
					callbackFunc(false)
				}
        
        // 请求失败时显示错误提示
        // 设置loading状态为false
        if (loadingState && typeof loadingState === 'object' && 'value' in loadingState) {
          loadingState.value = false;
        } else if (typeof loadingState === 'function') {
          loadingState(false);
        }
        
        // 请求失败时显示错误提示
        message.error('File export failed! Please try again.');
        
        // 移除loading元素
        if (loadingElement && document.body.contains(loadingElement)) {
          document.body.removeChild(loadingElement);
        }
			}
		}
	}
	if(method==='POST'){
		xhr.send(JSON.stringify(param));
	}
  else{
		xhr.send();
	}
}